import { Typography } from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import './styles.css';

export const ContactUs = () => {
    return (
        <Typography>
            <TelegramIcon className='logo' fontSize="large"  style={{ color: '#063970' }}></TelegramIcon>
            <span className='link'>
                <a href='https://t.me/kraymira'>@kraymira</a>
            </span>
        </Typography>
    )
}
